import React, { useEffect, useState } from "react";

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem("cookie_consent");
        if (!consent) {
            setIsVisible(true);
        }
    }, []);


    const handleConsent = (value) => {
        localStorage.setItem("cookie_consent", value);
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 w-full z-50 bg-white border-t border-gray-300 shadow-md p-4">
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <p className="text-sm text-gray-700">
                    This website uses cookies and local storage for performance and personalization.
                    Only essential cookies are turned on by default. Learn more in{" "}
                    <a href="https://iot.crompton.co.in/IoT/privacy-policy.html" target={"_blank"} className="underline text-[#004c86]">
                        Privacy Policy
                    </a> & &nbsp;
                    <a href="https://iot.crompton.co.in/IoT/cookie-policy.html" target={"_blank"} className="underline text-[#004c86]">
                        Cookie Policy
                    </a>
                </p>

                <div className="flex gap-2 flex-shrink-0">
                    <button
                        onClick={() => handleConsent("declined")}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md text-sm hover:bg-gray-300"
                    >
                        Decline
                    </button>
                    <button
                        onClick={() => handleConsent("accepted")}
                        className="px-4 py-2 bg-[#004c86] text-white rounded-md text-sm hover:bg-[#004c86]"
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
